import { BaseGetProvider } from "@tendercuts/http";
import { Injectable } from "@angular/core";
import { SaleOrder } from "@tendercuts/models";
import { HttpClient } from "@angular/common/http";
import { LoginServices } from "../login/services";
import { EndPoint } from "../base";
import { OrderHistoryPagination } from "../../models/order-history";

@Injectable({ providedIn: "root" })
export class OrderHistoryService extends BaseGetProvider<OrderHistoryPagination> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
  }

  get isCachable() {
    return false;
  }

  get isAuthenticatedEndpoint() {
    return true;
  }

  get authProtocol() {
    return this.loginService;
  }

  get model() {
    return OrderHistoryPagination;
  }

  get endpoint() {
    return this.endpointService.orderHistory();
  }

  getParams(index: number): { page: number} {
    return {
      page: index
    }
  }
}
